import { createApi } from '@reduxjs/toolkit/query/react'
import { AxiosResponse } from 'axios'
import { IUser, TwigLoginResponse, UserPassPayload } from '../../interfaces/auth/IUser'
import { authAxiosQuery } from '../../utils/axios/auth.axios'
import { readFromStorage } from '../../utils/webStorage'

export const authApi = createApi({
    reducerPath: 'auth',
    baseQuery: authAxiosQuery(),
    endpoints: (builder) => ({
        login: builder.mutation<TwigLoginResponse, UserPassPayload>({
            query: (payload) => ({
                url: '/dom/login',
                method: 'POST',
                data: payload
            })
        }),
        authWithAgent: builder.mutation<{
            data: {
                chatData: any,
                metadata: { accessToken: string, refreshToken: string, user: any, chatId: string, isAdmin?: boolean }
            }
        }, { linkToken: string, chatData: any, dashboard?: string, chatId?: string }>({
            query: (payload) => ({
                url: '/hotel-world-dom/activate-invited-user/chat',
                method: 'PUT',
                data: payload
            })
        }),
        signIn: builder.mutation<any, any>({
            query: (payload) => ({
                url: '/hotel-world-dom/hotel-admin/sign-in',
                method: 'PUT',
                data: payload
            })
        }),
        currentUser: builder.query<AxiosResponse<IUser>, {}>({
            query: (payload) => ({
                url: '/dom/authorize',
                method: 'POST',
                data: payload,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Authorization: `Bearer ${readFromStorage('accessToken')}`,
                },
            })
        }),
        refreshToken: builder.mutation<TwigLoginResponse, {}>({
            query: () => ({
                url: '/dom/refresh-token',
                method: 'POST',
                data: { token: readFromStorage('refreshToken') },
            })
        }),
        signInWithAgent: builder.mutation<{
            data: {
				chatId: string
                chatData: any
                metadata: { accessToken: string, refreshToken: string, user?: any, chatId: string, isAdmin?: boolean }
            },
        }, {
			chatId?: string,
            chatData: any,
            dashboard?: string
        }>({
            query: (payload) => ({
                url: '/hotel-world-dom/sign-in/chat',
                method: 'PUT',
                data: payload
            })
        }),
    }),
})

export const {
    useLoginMutation,
    useSignInMutation,
    useCurrentUserQuery,
    useRefreshTokenMutation,
    useAuthWithAgentMutation,
    useSignInWithAgentMutation
} = authApi